module.exports = {
  path: 'qrcode/:qrparam',
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require('./components/QRcode'));
    });
  }
};



// WEBPACK FOOTER //
// ./routes/qrcode/index.js